import { Col, Row } from "react-bootstrap";

const Footer = () => (
	<footer className="footer">
		<Row className="justify-content-between text-center fs--1 mt-4 mb-3">
			<Col sm="auto">
				<p className="mb-0 text-600">
					&copy; Copyright 2022{" "}
					<a href="https://ideaclip-11383.web.app/home">IDEACLIP</a>
					<span className="d-none d-sm-inline-block">| </span>
					<br className="d-sm-none" /> All Rights Reserved
				</p>
			</Col>
			<Col sm="auto">
				<p className="mb-0 text-600">v0.1.0</p>
			</Col>
		</Row>
	</footer>
);

export default Footer;
